import styled from '@emotion/styled';
import Button from 'antd/es/button';
import React from 'react';
import { useTranslate } from '@tolgee/react';
import { StoreInfo } from 'services/api/store';

interface Props {
  selected: StoreInfo[];
  onSubmit?: (lsit: StoreInfo[]) => void;
}

const Container = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 8px 6px;
  gap: 12px;
  height: 48px;
  background: rgba(255, 255, 255, 1);
  border-radius: 0 0 4px 4px;
  box-shadow: 0 -2px 8px 0 rgba(167, 178, 204, 0.1), inset 0 1px 0 0 rgba(240, 242, 245, 1);
  .tips {
    font-size: 14px;
    align-self: center;
    color: #b5b9bf;
  }
  button {
    font-size: 14px;
    height: 32px;
    line-height: 32px;
    padding: 0 24px;
  }
`;

const StoreListFooter = React.memo((props: Props) => {
  const { selected, onSubmit } = props;
  const { t } = useTranslate();
  if (!selected.length) {
    return null;
  }
  return (
    <Container>
      <span className="tips">{t('storeSelector.已选{x}', { x: selected.length })}</span>
      <Button type="primary" onClick={() => onSubmit?.(selected)}>
        {t('storeSelector.确认切换')}
      </Button>
    </Container>
  );
});

export default StoreListFooter;
